export default __webpack_public_path__ + "static/media/head_2_female.fcb4d47f.png";